/**
 * Defines the types related to payment methods in the account settings of the application.
 */
export enum PaymentMethodType {
  /** Credit or debit card. */
  Card = "card",

  /** US bank account (ACH). */
  UsBankAccount = "us_bank_account",

  /** Deposit applied. */
  DepositApplied = "deposit_applied",

  /** Credits applied. */
  CreditsApplied = "credits_applied",

  /** An Invoiced credit note written down against an invoice. */
  CreditNote = "credit_note",

  /** Cash. */
  Cash = "cash",

  /** Credits. */
  Credits = "credits",

  /** Issued credit. */
  IssuedCredit = "issued_credit",

  /** Deposit. */
  Deposit = "deposit",
}
